export const SET_FAQS = 'SET_FAQS';
